import { type NavigationAnchor } from "@/components/layout/types";
import {
  Module,
  PATH_CONTRACTOR_VISITS,
  PATH_CONTRACTOR_CARDS,
  PATH_CONTRACTOR_PANEL_PLANNED_HOURS,
  PATH_SURVEYS,
  PATH_TEMPLATES,
} from "@/constants";
import { useIsActiveContractor } from "@/modules/account/hooks/useIsActiveContractor";
import { useIsAdmin } from "@/modules/account/hooks/useIsAdmin";
import { usePermissions } from "@/modules/account/hooks/usePermissions";
import {
  ClipboardList,
  FileUser,
  FileText,
  NotepadText,
  NotepadTextDashed,
} from "lucide-react";
import { ContractorPermissions } from "@/modules/contractor/permissions/contractorPermissions";
import { useTranslation } from "react-i18next";

export const useMainMenuItems = (): NavigationAnchor[] => {
  const { t } = useTranslation();
  const permissions = usePermissions();
  const isAdmin = useIsAdmin();
  const isContractorActive = useIsActiveContractor();
  const hideContractorItems = !(isAdmin || isContractorActive);

  const items: NavigationAnchor[] = [
    {
      icon: NotepadText,
      url: PATH_SURVEYS,
      permission: permissions.surveys.can_read,
      title: t("navigation.surveys"),
    },
    {
      icon: NotepadTextDashed,
      url: PATH_TEMPLATES,
      permission: permissions[Module.SurveyTemplates].can_read,
      title: t("navigation.templates"),
    },
    {
      icon: FileUser,
      url: PATH_CONTRACTOR_VISITS,
      permission: permissions[Module.ContractorPanelVisits].can_read,
      hide: hideContractorItems,
      title: t("navigation.contractorVisitsPanel"),
    },
    {
      icon: FileText,
      url: PATH_CONTRACTOR_CARDS,
      permission: permissions[Module.ContractorPanelCards].can_read,
      hide: hideContractorItems,
      title: t("navigation.myContractorCards"),
    },
    {
      icon: ClipboardList,
      url: PATH_CONTRACTOR_PANEL_PLANNED_HOURS,
      permission: (permissions[Module.Contractors] as ContractorPermissions)
        .contractors_planned_hours_read,
      hide: hideContractorItems,
      title: t("navigation.contractorPanelSummary"),
    },
  ];

  return items;
};
